import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {Link} from "react-router-dom";

function nameColumn(cell, row) {
  return `${row.firstName} ${row.lastName}`;
}

class RegistrationRequestList extends Component {

  constructor(props) {
    super(props);
    this.renderActionButton = this.renderActionButton.bind(this);
  }

  renderActionButton(val, row) {
    return <Link to={`/settings/users/add/${row.registrationRequestId}`}>Create User</Link>
  }

  render() {
    return (
      <div>
        <BootstrapTable data={this.props.requests} tableHeaderClass="registration-list-table-header"
                        tableContainerClass={'wa-bootstrap-table-container'} keyField={"registrationRequestId"}>
          <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center"
                             dataFormat={nameColumn}>
            Name
          </TableHeaderColumn>
          <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center" dataField="company">
            Company
          </TableHeaderColumn>
          <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center" dataField="email">
            Email
          </TableHeaderColumn>
          <TableHeaderColumn width="55" className="headerColumnColor" dataField="message">
            Message
          </TableHeaderColumn>
          <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center"
                             dataFormat={this.renderActionButton}>
            Email
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

RegistrationRequestList.propTypes = {
  requests: PropTypes.array.isRequired
};

export default RegistrationRequestList;
